export const roundToNearestTenth = (daysCount: number): number =>
  Math.round(daysCount / 10) * 10
